import styled from 'react-emotion';

import { queries } from './mediaQueries';
import theme from './theme';

export const Logo = styled.div`
	background: white;
	color: ${theme.colors.primaryColor};
	font-family: ${theme.typography.roundedFontFamily};
	font-size: 1.5rem;
	height: 50px;
	padding-top: 7px;
	padding-left: 10px;
  	padding-right: auto;
  	border-right: 1px solid rgb(204, 204, 204);
  	border-bottom: 1px solid rgb(204, 204, 204);

	
	.logo {
  		max-height: 50px;
  		vertical-align: middle;
  		width: auto;
  		height: auto;
  		
  	}
	${queries.xLarge`
		height: ${theme.grid.topXLargeTextSearchHeight};
		min-height: ${theme.grid.topXLargeTextSearchHeight};
		font-size: 1.2rem;
		margin: 0px;
		margin-top: ${theme.grid.topXLargeMargin};
	`};
	${queries.medium`
		font-size: 1.5rem;
		width: auto;
		margin-top: ${theme.grid.topXLargeMargin};
		display: flex;
		flex-direction: column;
		text-align: center;
		padding: 4px;
		margin-left: ${theme.grid.topXLargeMarginSides};
		margin-right: ${theme.grid.topXLargeMarginSides};
		border-radius: 5px;
		box-shadow: 2px 2px 3px black;
	`};
`;

const Navbar = styled.nav`
	background: ${theme.colors.secondaryColor};
	left: 0;
	width: ${theme.grid.leftAreaWidth};
	height: 100vh;
	position: fixed;
	z-index: 3;

	${({ full }) => queries.xLarge`
		width: 100%;
		height: ${full ? '100vh' : 'auto'};
		display: flex;
		flex-direction: column;
	`};
`;

export default Navbar;



// WEBPACK FOOTER //
// ./src/styles/Navbar.js